export const GA4_MEASUREMENT_ID = "G-80H8D06X0F";
export const GOOGLE_ADS_ID = "AW-18397565871";
export const GOOGLE_ADS_CONVERSION = "AW-18397565871/rexdCLLU3vAcEK-n0sRE";

const waitForGtag = (callback, attempts = 0) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    callback();
    return;
  }
  if (attempts < 40) {
    setTimeout(() => waitForGtag(callback, attempts + 1), 50);
  }
};

/**
 * Order-confirmation conversion only.
 * No user_data, enhanced conversions, or product/drug fields.
 */
export const fireGoogleAdsConversion = ({ value, transactionId }) => {
  const id = transactionId ? String(transactionId) : "";
  if (!id) return;

  const dedupeKey = `rx_aw_conversion_${id}`;
  try {
    if (sessionStorage.getItem(dedupeKey)) return;
  } catch (err) {
    // continue
  }

  const amount = Number.parseFloat(value);
  waitForGtag(() => {
    window.gtag("event", "conversion", {
      send_to: GOOGLE_ADS_CONVERSION,
      value: Number.isFinite(amount) ? amount : 0,
      currency: "USD",
      transaction_id: id,
    });
    try {
      sessionStorage.setItem(dedupeKey, "1");
    } catch (err) {
      // ignore
    }
  });
};
